module.exports = __webpack_public_path__ + "img/btn-icon-7.687bdbb2.png";